<template>
  <div class="searchFilters">
    <component
      :is="filter.type"
      v-for="(filter, key) in filters"
      :id="`${prefix}_${filter.key}`"
      :key="key"
      :name="filter.key"
      :value="activeFilters[filter.key]"
      :label="filter.name"
      :input-value="filter.value"
      :options="filter.values"
      :available="filter.available"
      :min="filter.min"
      :max="filter.max"
      :collapse-count="2"
      mobile-collapse
      :postfix="filter.postfix"
      :class="['searchFilters__item', `searchFilters__item--${filter.type}`]"
      @emitObject="onFilterChange"
    />
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import FormField from '~/components/Form/FormField';
import FormCheckbox from '~/components/Form/FormCheckbox';
import FormCheckboxList from '~/components/Form/FormCheckboxList';
import FormRange from '~/components/Form/FormRange';
import FormRadio from '~/components/Form/FormRadio';

export default {
  name: 'SearchFilters',
  components: {
    FormField,
    FormCheckbox,
    FormCheckboxList,
    FormRange,
    FormRadio,
  },
  props: {
    prefix: {
      type: String,
      default: '',
    },
  },
  computed: {
    ...mapState({
      activeFilters: state => state.productsFilters.search.activeFilters,
      filters: state => state.productsFilters.search.filters,
    }),
  },
  methods: {
    ...mapActions({
      changeFilters: 'productsFilters/changeFilters',
    }),
    onFilterChange({ name, value }) {
      this.changeFilters({ type: 'search', name, value });
    },
  },
};
</script>

<style lang="scss">
.searchFilters {
  &__item {
    margin-bottom: 3rem;

    &--FormCheckboxList,
    &--FormRadio,
    &--FormRange {
      @include rwd('large-tablet') {
        margin-bottom: 0;
      }
    }

    &--FormCheckbox {
      margin-top: 3rem;
    }

    &--FormRange {
      padding-bottom: 1rem;

      @include rwd('large-tablet') {
        border-bottom: 1px solid $cAddLight;
        padding-bottom: 4rem;
        padding-top: 3rem;
      }
    }
  }
}
</style>
